"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-seventeen/section/aboutSection.tsx */

import { SmartImage } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type AboutSection6sItem = {
    key: Key | null | undefined;
    /** Detected variants: "mission" | "vision" */
    alt: string;
    /** Detected variants: "/Templates/Doccure/img/icons/mission-05.svg" | "/Templates/Doccure/img/icons/vision-05.svg" */
    src: string;
    /** Detected variants: "Mission" | "Vision" */
    h30Text: ReactNode;
    /** Detected variants: "To provide holistic and nurturing eye care that promotes healing through advanced technology." | "To be a premier wellness center known for exceptional holistic care and a patient approach to health." */
    p0Text: ReactNode;
    /** Detected variants: "col-md-6 d-flex" */
    className?: string;
    /** Detected variants: "mission-item-two flex-fill wow fadeInUp" */
    div0ClassName?: string;
    /** Detected variants: "0.2s" */
    dataWowDelay?: string;
    /** Detected variants: "1s" */
    dataWowDuration?: string;
    /** Detected variants: "mission-inner" */
    div0ClassName2?: string;
    /** Detected variants: "mission-icon" */
    div0ClassName3?: string;
    /** Detected variants: "img-fluid" */
    imageWithBasePath0ClassName?: string;
    /** Detected variants: "custom-title" */
    h30ClassName?: string;
};

type AboutSectionAvatarsItem = {
    key: Key | null | undefined;
    /** Detected variants: "/Templates/Doccure/img/users/user-sm-1.jpg" | "/Templates/Doccure/img/users/user-sm-2.jpg" | "/Templates/Doccure/img/users/user-sm-3.jpg" | "/Templates/Doccure/img/users/user-sm-4.jpg" */
    src: string;
    /** Detected variants: "avatar" */
    className?: string;
    /** Detected variants: "patient" */
    alt?: string;
    /** Detected variants: "img-fluid rounded-circle border border-white" */
    imageWithBasePath0ClassName?: string;
};
export type HomeSeventeenAboutSectionGeneratedProps = {
    divDiv0Div0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: AboutSection6sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv0Div0H30H3Props?: Partial<ComponentProps<"h3">> | ((item: AboutSection6sItem) => Partial<ComponentProps<"h3">>);
    sectionDiv0Div0ClassName?: string;
    /** Default: "about" */
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/about/about-06.png" */
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "More then 25K clients reviews" */
    sectionDiv0Div0Div1Div0Div0P0PText?: ReactNode;
    /** Default: "1s" */
    sectionDiv0Div0Div1Div0Div1DivDataWowDuration?: string;
    /** Default: "Comprehensive care for every dimension of you" */
    sectionDiv0Div0Div1Div0Div1H20H2Text?: ReactNode;
    sectionDiv0Div0Div1Div0Div1H20H2Visible?: boolean;
    sectionDiv0Div0Div1Div0Div1H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div1Div0Div1H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "The Harmony Integration Method combines ancient healing wisdom with modern scientific research. We don't just treat symptoms we identify and address root causes through a comprehensive mind-body-spirit approach." */
    sectionDiv0Div0Div1Div0Div1P0PText?: ReactNode;
    sectionDiv0Div0Div1Div0Div2ClassName?: string;
    /** Default: "bg" */
    sectionImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/shape-01.png" */
    sectionImageWithBasePath0ImageSrc?: string;
    sectionImageWithBasePath0ImageVisible?: boolean;
    sectionImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "bg" */
    sectionImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/shape-01.png" */
    sectionImageWithBasePath1ImageSrc?: string;
    sectionImageWithBasePath1ImageVisible?: boolean;
    sectionImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    spanImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: AboutSectionAvatarsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    aboutSection6s: AboutSection6sItem[];
    aboutSectionAvatars: AboutSectionAvatarsItem[];
    aboutSection6sItemWrapper?: (item: AboutSection6sItem, content: ReactNode) => ReactNode;
    aboutSection6sRenderer?: (defaultNode: ReactNode) => ReactNode;
    aboutSection6sImageVisible?: boolean;
    aboutSection6sImageRenderer?: (item: AboutSection6sItem, defaultNode: ReactNode) => ReactNode;
    aboutSection6sH3Visible?: boolean;
    aboutSection6sH3Renderer?: (item: AboutSection6sItem, defaultNode: ReactNode) => ReactNode;
    aboutSection6sImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: AboutSection6sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    aboutSection6sH3Props?: Partial<ComponentProps<"h3">> | ((item: AboutSection6sItem) => Partial<ComponentProps<"h3">>);
    aboutSectionAvatarsItemWrapper?: (item: AboutSectionAvatarsItem, content: ReactNode) => ReactNode;
    aboutSectionAvatarsRenderer?: (defaultNode: ReactNode) => ReactNode;
    aboutSectionAvatarsImageVisible?: boolean;
    aboutSectionAvatarsImageRenderer?: (item: AboutSectionAvatarsItem, defaultNode: ReactNode) => ReactNode;
    aboutSectionAvatarsImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: AboutSectionAvatarsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
};

const HomeSeventeenAboutSectionGenerated: FC<HomeSeventeenAboutSectionGeneratedProps> = ({
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageAlt = "about",
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/about/about-06.png",
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageVisible,
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0Div0Div0ImageWithBasePath0ImageProps,
    sectionDiv0Div0Div1Div0Div0P0PText = "More then 25K clients reviews",
    sectionDiv0Div0Div1Div0Div1DivDataWowDuration = "1s",
    sectionDiv0Div0Div1Div0Div1H20H2Text = "Comprehensive care for every dimension of you",
    sectionDiv0Div0Div1Div0Div1H20H2Visible,
    sectionDiv0Div0Div1Div0Div1H20H2Renderer,
    sectionDiv0Div0Div1Div0Div1H20H2Props,
    sectionDiv0Div0Div1Div0Div1P0PText = "The Harmony Integration Method combines ancient healing wisdom with modern scientific research. We don't just treat symptoms we identify and address root causes through a comprehensive mind-body-spirit approach.",
    sectionImageWithBasePath0ImageAlt = "bg",
    sectionImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/shape-01.png",
    sectionImageWithBasePath0ImageVisible,
    sectionImageWithBasePath0ImageRenderer,
    sectionImageWithBasePath0ImageProps,
    sectionImageWithBasePath1ImageAlt = "bg",
    sectionImageWithBasePath1ImageSrc = "/Templates/Doccure/img/bg/shape-01.png",
    sectionImageWithBasePath1ImageVisible,
    sectionImageWithBasePath1ImageRenderer,
    sectionImageWithBasePath1ImageProps,
    divDiv0Div0Div0ImageWithBasePath0ImageProps,
    divDiv0Div0H30H3Props,
    spanImageWithBasePath0ImageProps,
    sectionDiv0Div0ClassName,
    sectionDiv0Div0Div1Div0Div2ClassName,
    aboutSection6s,
    aboutSectionAvatars,
    aboutSection6sItemWrapper,
    aboutSection6sRenderer,
    aboutSection6sImageVisible,
    aboutSection6sImageRenderer,
    aboutSection6sH3Visible,
    aboutSection6sH3Renderer,
    aboutSection6sImageProps,
    aboutSection6sH3Props,
    aboutSectionAvatarsItemWrapper,
    aboutSectionAvatarsRenderer,
    aboutSectionAvatarsImageVisible,
    aboutSectionAvatarsImageRenderer,
    aboutSectionAvatarsImageProps,
}) => {
    return (
        <section className="about-section-seventeen section">
            <div className="container">
                <div className={sectionDiv0Div0ClassName ?? "row align-items-center g-4"}>
                    <div className="col-lg-5">
                        <div className="about-img-seventeen">
                            {renderNode(sectionDiv0Div0Div0Div0ImageWithBasePath0ImageVisible, sectionDiv0Div0Div0Div0ImageWithBasePath0ImageRenderer, (
                                <SmartImage src={sectionDiv0Div0Div0Div0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div0Div0Div0ImageWithBasePath0ImageAlt} className="img-fluid" {...(sectionDiv0Div0Div0Div0ImageWithBasePath0ImageProps ?? {})} />
                            ))}
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="about-content-seventeen">
                            <div className="rating-user">
                                <div className="avatar-list-stacked">
                                    {renderCollectionNode(
                                        aboutSectionAvatars,
                                        (item: AboutSectionAvatarsItem) => (
                                            <span className={item.className ?? "avatar"} key={item.key}>
                                                {renderItemNode(aboutSectionAvatarsImageVisible, aboutSectionAvatarsImageRenderer, item, (
                                                    <SmartImage src={item.src} alt={item.alt ?? "patient"} className={item.imageWithBasePath0ClassName ?? "img-fluid rounded-circle border border-white"} {...(typeof aboutSectionAvatarsImageProps === "function" ? aboutSectionAvatarsImageProps(item) : (aboutSectionAvatarsImageProps ?? {}))} {...(typeof spanImageWithBasePath0ImageProps === "function" ? spanImageWithBasePath0ImageProps(item) : (spanImageWithBasePath0ImageProps ?? {}))} />
                                                ))}
                                            </span>
                                        ),
                                        aboutSectionAvatarsItemWrapper,
                                        aboutSectionAvatarsRenderer
                                    )}
                                </div>
                                <p>{sectionDiv0Div0Div1Div0Div0P0PText}</p>
                            </div>
                            <div className="section-header section-header-seventeen wow fadeInUp" data-wow-duration={sectionDiv0Div0Div1Div0Div1DivDataWowDuration}>
                                {renderNode(sectionDiv0Div0Div1Div0Div1H20H2Visible, sectionDiv0Div0Div1Div0Div1H20H2Renderer, (
                                    <h2 className="section-title text-gradient" {...(sectionDiv0Div0Div1Div0Div1H20H2Props ?? {})}>{sectionDiv0Div0Div1Div0Div1H20H2Text}</h2>
                                ))}
                                <p className="description mb-0">{sectionDiv0Div0Div1Div0Div1P0PText}</p>
                            </div>
                            <div className={sectionDiv0Div0Div1Div0Div2ClassName ?? "row g-4"}>
                                {renderCollectionNode(
                                    aboutSection6s,
                                    (item: AboutSection6sItem) => (
                                        <div className={item.className ?? "col-md-6 d-flex"} key={item.key}>
                                            <div className={item.div0ClassName ?? "mission-item-two flex-fill wow fadeInUp"} data-wow-delay={item.dataWowDelay ?? "0.2s"} data-wow-duration={item.dataWowDuration ?? "1s"}>
                                                <div className={item.div0ClassName2 ?? "mission-inner"}>
                                                    <div className={item.div0ClassName3 ?? "mission-icon"}>
                                                        {renderItemNode(aboutSection6sImageVisible, aboutSection6sImageRenderer, item, (
                                                            <SmartImage src={item.src} alt={item.alt} className={item.imageWithBasePath0ClassName ?? "img-fluid"} {...(typeof aboutSection6sImageProps === "function" ? aboutSection6sImageProps(item) : (aboutSection6sImageProps ?? {}))} {...(typeof divDiv0Div0Div0ImageWithBasePath0ImageProps === "function" ? divDiv0Div0Div0ImageWithBasePath0ImageProps(item) : (divDiv0Div0Div0ImageWithBasePath0ImageProps ?? {}))} />
                                                        ))}
                                                    </div>
                                                    {renderItemNode(aboutSection6sH3Visible, aboutSection6sH3Renderer, item, (
                                                        <h3 className={item.h30ClassName ?? "custom-title"} {...(typeof aboutSection6sH3Props === "function" ? aboutSection6sH3Props(item) : (aboutSection6sH3Props ?? {}))} {...(typeof divDiv0Div0H30H3Props === "function" ? divDiv0Div0H30H3Props(item) : (divDiv0Div0H30H3Props ?? {}))}>{item.h30Text}</h3>
                                                    ))}
                                                    <p>{item.p0Text}</p>
                                                </div>
                                            </div>
                                        </div>
                                    ),
                                    aboutSection6sItemWrapper,
                                    aboutSection6sRenderer
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {renderNode(sectionImageWithBasePath0ImageVisible, sectionImageWithBasePath0ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath0ImageSrc} alt={sectionImageWithBasePath0ImageAlt} className="about-bg-01 rotate-anime" {...(sectionImageWithBasePath0ImageProps ?? {})} />
            ))}
            {renderNode(sectionImageWithBasePath1ImageVisible, sectionImageWithBasePath1ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath1ImageSrc} alt={sectionImageWithBasePath1ImageAlt} className="about-bg-02 rotate-anime" {...(sectionImageWithBasePath1ImageProps ?? {})} />
            ))}
        </section>
    );
};

export default HomeSeventeenAboutSectionGenerated;
